import React, { useCallback, useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import './FrameCarousel.css'

import image1 from '../../images/visToolPreview1.jpg'
import image2 from '../../images/visToolPreview2.jpg'
import image3 from '../../images/visToolPreview4.jpg'
import { ENDPOINT_PATH } from '../../config';







export default function FrameCarousel() {
    const [frameIcons, setFrameIcons] = useState([])


    async function getFullFrameData() {
        try {
            const response = await fetch(`${ENDPOINT_PATH}/api/frames`)
            const frameData = await response.json()

            const framesWithImages = (await Promise.all(
                frameData.map(async (frame) => {
                    if (frame.frameName !== "noSelectedFrame") {
                        const params = new URLSearchParams({
                            frameName: frame.frameName,
                            frameType: frame.frameType,
                            frameThickness: frame.frameThicknessAvailable[0],
                            frameSize: '8_10'
                        })
                        const imageResponse = await fetch(`${ENDPOINT_PATH}/api/frame-image?${params}`)
                        const imageUrl = await imageResponse.json()
                        return {
                            ...frame,
                            id: frame.frameName,
                            image: imageUrl
                        }
                    }
                    return null;
                })
            )).filter(Boolean); // Remote null/undefined values

            setFrameIcons(framesWithImages)
        } catch (error) {
            console.error('Error fetching frames:', error)
        }
    }

    useEffect(() => {
        getFullFrameData()
    }, [])

    useEffect(() => {
        console.log(frameIcons)
    }, [frameIcons])
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true })

    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev()
    }, [emblaApi])

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext()
    }, [emblaApi])

    return (
        <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {/* <div className="embla__slide">
                        <img className="embla__slide__img" src={image1} alt="Frame example 1" />
                    </div>
                    <div className="embla__slide">
                        <img className="embla__slide__img" src={image2} alt="Frame example 2" />
                    </div>
                    <div className="embla__slide">
                        <img className="embla__slide__img" src={image3} alt="Frame example 3" />
                    </div> */}
                    {frameIcons.map((frameIcon) => (
                        <div className="embla__slide" key={frameIcon.frameName}>
                            <div className="embla__slide__inner">
                                <img className="embla__slide__img" src={frameIcon.image} alt="Frame example" />
                                <div className="embla__slide__info">
                                    <h3>{frameIcon.displayName}</h3>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <button className="embla__prev" onClick={scrollPrev}>{'<'}</button>
            <button className="embla__next" onClick={scrollNext}>{'>'}</button>
        </div>
    )
}
